import { useLanguage } from '../contexts/LanguageContext';
import { portfolioTranslations } from '../data/portfolioTranslations';

export const usePortfolioTranslation = () => {
    const { currentLanguage } = useLanguage();

    const getTranslatedContent = (category, key, field = null) => {
        const translations = portfolioTranslations[currentLanguage];

        if (!translations || !translations[category] || !translations[category][key]) {
            // Fallback to English if translation doesn't exist
            const fallback = portfolioTranslations.en;
            if (fallback && fallback[category] && fallback[category][key]) {
                return field ? fallback[category][key][field] : fallback[category][key];
            }
            return null;
        }

        const content = translations[category][key];
        return field ? content[field] : content;
    };

    const translateExperience = (experienceKey) => {
        return getTranslatedContent('experiences', experienceKey);
    };

    const translateProject = (projectKey) => {
        return getTranslatedContent('projects', projectKey);
    };

    const translateHackathon = (hackathonKey) => {
        return getTranslatedContent('hackathons', hackathonKey);
    };

    const translateEducation = (educationKey) => {
        return getTranslatedContent('education', educationKey);
    };

    return {
        translateExperience,
        translateProject,
        translateHackathon,
        translateEducation,
        getTranslatedContent
    };
};